export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const BASE_DASHBOARD_URL = process.env.REACT_APP_BASE_DASHBOARD_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_PICKUP_URL = process.env.REACT_APP_BASE_PICKUP_URL;
export const BASE_MARKETPLACE_URL = process.env.REACT_APP_BASE_MARKETPLACE_URL;
export const DRIVER_SEARCH_URL = process.env.REACT_APP_DRIVER_SEARCH_URL;
export const BASE_SMR_URL = process.env.REACT_APP_BASE_SMR_URL;
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const COUNTRY_URL = process.env.COUNTRY_URL || '';
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_API_KEY;
export const MULTIVERSE_SOCKET_URL = process.env.REACT_APP_MULTIVERSE_SOCKET_URL;
